var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNumber = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "iPhone 8")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-number",
    transform: "translate(7.000000, 3.000000)",
    fill: "#001640",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47753911,16.6666667 L9.47753911,16.1083984 C8.35340711,16.1083984 7.65462244,15.9564887 7.38118489,15.6526692 C7.10774744,15.3488498 6.97102867,14.7715929 6.97102867,13.9208984 L6.97102867,13.9208984 L6.97102867,0.625 L6.56087244,0.625 L0.670572911,3.1656901 L0.670572911,3.75813802 C1.10351562,3.59103732 1.4453125,3.46950954 1.69596354,3.39355469 C2.09092882,3.26443142 2.383355,3.19986979 2.57324222,3.19986979 C2.93023,3.19986979 3.17518444,3.32139757 3.30810544,3.56445312 C3.44102644,3.80750868 3.507487,4.21766493 3.507487,4.79492188 L3.507487,4.79492188 L3.507487,13.7841797 C3.507487,14.6880426 3.34038633,15.301378 3.00618489,15.6241862 C2.67198356,15.9469943 1.9124349,16.1083984 0.727539067,16.1083984 L0.727539067,16.1083984 L0.727539067,16.6666667 L9.47753911,16.6666667 Z",
    id: 1
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNumber, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/number.5541b32a.svg";
export { ForwardRef as ReactComponent };